<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="header">
  <div class="header-left">
    <ng-content select="[beginning]"></ng-content>
    <img
      class="logo"
      src="assets/img/logo.svg"
      alt="Ground logo"
      (click)="onSurveysButtonClick()"
    />
    <span class="ground-title">Ground</span>
    <ng-content select="[left]"></ng-content>
  </div>

  <div>
    <ng-container *ngIf="canManage">
      <ng-container *ngIf="state === HeaderState.MAP_VIEW">
        <button mat-icon-button [matMenuTriggerFor]="editSurveyMenu">
          <mat-icon>settings</mat-icon>
        </button>

        <mat-menu #editSurveyMenu="matMenu">
          <a (click)="onEditSurveyClick()">
            <button mat-menu-item>
              <ng-container i18n="@@app.labels.manageSurvey"
                >Manage survey</ng-container
              >
            </button>
          </a>
        </mat-menu>

        <div class="header-divider"></div>
      </ng-container>

      <ng-container *ngIf="state === HeaderState.EDIT_SURVEY">
        <button
          mat-button
          class="cancel-edit-button"
          (click)="onCancelEditSurveyClick()"
        >
          <ng-container i18n="@@app.labels.cancel">Cancel</ng-container>
        </button>

        <button
          mat-flat-button
          class="finish-edit-button"
          [disabled]="isPublishingChanges"
          (click)="onFinishEditSurveyClick()"
        >
          <ng-container i18n="@@app.labels.publishChanges"
            >Publish changes</ng-container
          >

          <mat-icon *ngIf="isPublishingChanges">
            <mat-spinner diameter="18"></mat-spinner>
          </mat-icon>
        </button>

        <div class="header-divider"></div>
      </ng-container>
    </ng-container>

    <ground-language-switcher></ground-language-switcher>

    <ng-container *ngIf="authService.getUser$() | async as user">
      <button mat-icon-button [matMenuTriggerFor]="infoMenu">
        <mat-icon>info_outline_24px</mat-icon>
      </button>

      <mat-menu #infoMenu="matMenu">
        <a *ngIf="user.isAuthenticated" (click)="onTermsOfServiceClick()">
          <button mat-menu-item>
            <ng-container i18n="@@app.labels.termsOfService"
              >Terms of service</ng-container
            >
          </button>
        </a>

        <a (click)="onAboutClick()">
          <button mat-menu-item i18n="@@app.labels.about">About</button>
        </a>
      </mat-menu>
    </ng-container>

    <ground-current-user-widget></ground-current-user-widget>
  </div>
</div>
